// extracted by mini-css-extract-plugin
module.exports = {"body":"FormBody_body__1kT3J","subtitle":"FormBody_subtitle__2vhw_"};